import {
    Flex,
    Container,
    Stack,
    Heading,
    SimpleGrid,
    Box,
    Text,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    useColorModeValue
} from '@chakra-ui/react'

import CustomHighlight from '../../../Components/Elements/CustomHighlight'

//import FaqItem from '../Shared/FAQ/FaqItem'
// import FaqItem from '../../../Components/Shared/FAQ/FaqItem'
import { FaqItem } from '../../../Components/FAQ'

import faqdata from '../../../Config/json/Pricing/faq.json'

const FaqList = () => {

    return (
        <Flex
            w={'full'}
            h={'40vg'}
            // pt={5}
            pb={'10vh'}
        >
            <Container
                maxW={'6xl'}
            >
                <Stack spacing={'10vh'}>
                    <Heading textAlign={'center'}>
                        <CustomHighlight query={['Frequently Asked Questions']}>Frequently Asked Questions</CustomHighlight>
                    </Heading>

                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} w={'full'}>
                        {
                            faqdata.map((currentFaq) => (
                                <FaqItem question={currentFaq.question} answer={currentFaq.answer} key={currentFaq.question} />
                            ))
                        }
                    </SimpleGrid>
                </Stack>
            </Container>
        </Flex>
    )
}

export default FaqList